export default "__VITE_ASSET__C$4m9JLu__"